<template>
  <div>
    <el-dialog
      title="费用申请抵扣借支"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="900px"
      :close-on-click-modal="false"
    >
      <section class="dialogContent">
        <!-- <section>
          <span>申请金额：</span>
          <span>未核销金额合计：</span>
        </section> -->
        <TableBox :isRadio="isRadio" ref="tableBox" />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="choose" :loading="subLoading">确定</el-button>
      </section>
    </el-dialog>
    <div
      class="chooseShowBox posire cur"
      :class="{active: Boolean(resultAmount)}"
      @click="showChooseDialog"
    >
      {{resultAmount || '请选择'}}
      <i class="el-icon-arrow-down posiab downIcon" />
    </div>
  </div>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'cc',
  },
  props: {
    resultVal: {
      default: '',
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    acUserId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      text: '',
      radioResult: {},
      checkboxResult: [],
      tableData: {
        title: [
          {
            prop: 'customerCode',
            label: '司机姓名',
          },
          {
            prop: 'companyName',
            label: '司机手机',
          },
        ],
      },
    };
  },
  computed: {
    resultAmount () {
      if (!this.resultVal) {
        return '';
      }
      const result = this.resultVal.reduce((last, next) => ({amount: last.amount + next.amount}), {amount: 0});
      return result.amount;
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
    showChooseDialog () {
      if (!this.acUserId) {
        this.$message.warning('请先选择收款人');
        return;
      }
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.sub({
          acUserId: this.acUserId,
        });
      });
    },
    cancle () {
      this.dialogFormVisible = false;
      this.$refs.tableBox.tableData.selectResult = [];
    },
    choose () {
      if (this.isRadio) {
        this.radioResult = this.$refs.tableBox.getSelectRadioData(); // 单选
        this.$emit('cc', this.radioResult);
        this.$emit('change', this.radioResult);
      } else {
        this.checkboxResult = this.$refs.tableBox.getSelectData();
        this.$emit('cc', this.checkboxResult);
        this.$emit('change', this.checkboxResult);
      }
      this.dialogFormVisible = false;
      this.$refs.tableBox.tableData.selectResult = [];
    },
    delCheckboxSelect (item) {
      this.checkboxResult.splice(this.checkboxResult.indexOf(item), 1);
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent{
  padding-bottom: 24px;
}
.searchBox{
  ::v-deep .customForm{
    margin: 0;
  }
}
::v-deep .el-radio-group{
  width: 100%;
}
.chooseShowBox{
  height: 32px;
  line-height: 32px;
  width: 240px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #C0C4CC;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .downIcon{
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #C0C4CC;
  }
}
.active{
  color: #333;
}
</style>
